import { fromJS, List } from 'immutable';
import NotificationRecord from 'records/notification';
import { createSymbols } from 'utils/helpers';
import { collectionReducer } from 'utils/reducerGenerator';

export const {
    DELETE_ALL_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS,
    FETCH_NOTIFICATIONS_FAIL,
    FETCH_NOTIFICATIONS_SUCCESS,
} = createSymbols([
    'DELETE_ALL_NOTIFICATIONS_SUCCESS',
    'FETCH_NOTIFICATIONS',
    'FETCH_NOTIFICATIONS_FAIL',
    'FETCH_NOTIFICATIONS_SUCCESS',
]);

const fetchNotifications = (state) => state.setIn(['notificationTypes', 'isFetching'], true);

const fetchNotificationsFinish = (state) => state.setIn(['notificationTypes', 'isFetching'], false);

const fetchNotificationsSuccess = (state, { payload }) => {
    const types = List().withMutations((mutList) => {
        payload.data.reduce((tally, value) => {
            const index = tally.findKey((tallyItem) => {
                return tallyItem.get('type') === value.type;
            });
            if (index !== undefined) {
                return tally.setIn([index, 'count'], Number(tally.getIn([index, 'count'])) + 1);
            }
            return tally.push(fromJS({ count: 1, type: value.type }));
        }, mutList);
    });

    const updatedState = state.set(
        'notificationTypes',
        fromJS({ data: fromJS(types), pagination: payload.pagination })
    );

    return fetchNotificationsFinish(updatedState, 'notificationTypes');
};

const deleteNotifications = (state, { meta }) => {
    const data = state.getIn(['notificationTypes', 'data']).filter((item) => item.get('type') !== meta.previousAction.data.type);

    return fetchNotificationsFinish(
        state.setIn(['notificationTypes', 'data'], data).set('data', List())
    );
};

export const { reducer, types } = collectionReducer(
    { namespace: 'NOTIFICATION', transformer: NotificationRecord },
    () => ({
        [DELETE_ALL_NOTIFICATIONS_SUCCESS]: deleteNotifications,
        [FETCH_NOTIFICATIONS]: fetchNotifications,
        [FETCH_NOTIFICATIONS_FAIL]: fetchNotificationsFinish,
        [FETCH_NOTIFICATIONS_SUCCESS]: fetchNotificationsSuccess,
    })
);

export default reducer;
